import strings from '../../Localization/Localization';

let price = {
  fieldKey: "price",
  type: "price",
  label: strings.form.creditPackPreviousPrice.price.label,
  validators: []
}

let quantity = {
  fieldKey: "quantity",
  type: "text",
  label: strings.form.creditPackPreviousPrice.quantity.label,
  validators: []
}

let quantityFree = {
  fieldKey: "quantity_free",
  type: "text",
  label: strings.form.creditPackPreviousPrice.quantityFree.label,
  defaultValue: 0,
  validators: []
}

let modifiedAt = {
  fieldKey: "modified_at",
  type: "date",
  label: strings.form.creditPackPreviousPrice.modifiedAt.label,
  validators: []
}

export const form = {
  formKey: "creditPackPreviousPrice",
  fields: [
    price,
    quantity,
    quantityFree,
    modifiedAt
  ]
}
